{
  "services": {
    "sidebar": {
      "close": "",
      "select": {
        "bound": "",
        "flight": "",
        "select": ""
      }
    }
  },
  "ancillaries": {
    "bundle": {
      "toggle": {
        "comboOfferText": "Kombotarjous"
      }
    },
    "selectPet": "",
    "wifi": {
      "selectWifi": ""
    },
    "selectMeals": "",
    "selectLounge": "",
    "selectSport": ""
  }
}
